import {CommonModule} from "@angular/common";
import {FlexLayoutModule} from "@angular/flex-layout";
import {NgModule} from "@angular/core";
import {RootPageComponent} from "./pages/gateway/root-page.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InstallBuildingComponent} from "./pages/gateway/components/install-building/install-building.component";
import {DialogModule} from "@angular/cdk/dialog";
import {InstallSensorsComponent} from "./pages/gateway/components/install-sensors/install-sensors.component";
import {
  InstallHeatingInformationComponent
} from "./pages/gateway/components/install-heating/components/install-heating-information/install-heating-information.component";
import {DataResultComponent} from "./components/data-result/data-result.component";
import {ImageInputComponent} from "./components/image-input/image-input.component";
import {TabsComponent} from "./components/tabs/tabs.component";
import {
  InstallSensorsTemperatureComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-temperature/install-sensors-temperature.component";
import {
  InstallSensorsCounterComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-counter/install-sensors-counter.component";
import {InputCheckBoxComponent} from "./components/input-check-box/input-check-box.component";
import {
  InstallSensorsOtherComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-other/install-sensors-other.component";
import {InstallPhotosComponent} from "./pages/gateway/components/install-photos/install-photos.component";
import {InputOnOffComponent} from "./components/input-on-off/input-on-off.component";
import {SpinnerComponent} from "./components/spinner/spinner.component";
import {InfoModalComponent} from "./components/info-modal/info-modal.component";
import {MinMaxNumberDirective} from "./validators/min-max-number.directive";
import {RawDataModalComponent} from "./components/raw-data-modal/raw-data-modal.component";
import {SerialNumberModalComponent} from './components/serial-number-modal/serial-number-modal.component';
import {LoginComponent} from './pages/login/login.component';
import {InputImageUploadComponent} from './components/sensor-image-upload/input-image-upload.component';
import {ImageModalComponent} from './components/image-modal/image-modal.component';
import {PreviewModalComponent} from './components/preview-modal/preview-modal.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {AlertComponent} from "./components/alert/alert.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {PlannerPageComponent} from './pages/planner/planner-page.component';
import {RouterLink, RouterLinkActive, RouterOutlet, ɵEmptyOutletComponent} from '@angular/router';
import {AgmCoreModule} from '@agm/core';
import {AgmMarkerSpiderModule} from 'agm-spiderfier';
import {SiteDetailModalComponent} from './pages/planner/components/site-detail-modal/site-detail-modal.component';
import {
  CreateSiteDetailModalComponent
} from './pages/planner/components/create-site-detail-modal/create-site-detail-modal.component';
import {InstallHeatingComponent} from './pages/gateway/components/install-heating/install-heating.component';
import {
  InstallHeatingCheckComponent
} from './pages/gateway/components/install-heating/components/install-heating-check/install-heating-check.component';
import {InstallGeneralComponent} from './pages/gateway/components/install-general/install-general.component';
import {
  InstallGeneralPrePhotosComponent
} from './pages/gateway/components/install-general/components/install-general-pre-photos/install-general-pre-photos.component';
import {
  InstallGeneralGatewayComponent
} from './pages/gateway/components/install-general/components/install-general-gateway/install-general-gateway.component';
import {
  InstallGeneralSendingComponent
} from './pages/gateway/components/install-general/components/install-general-sending/install-general-sending.component';
import {
  InstallGeneralMeasurementComponent
} from './pages/gateway/components/install-general/components/install-general-measurement/install-general-measurement.component';
import {
  InstallSensorsControlComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-control/install-sensors-control.component";
import {
  InstallSensorsPumpComponent
} from "./pages/gateway/components/install-sensors/components/install-sensors-pump/install-sensors-pump.component";
import {NavigationFooterComponent} from './components/navigation-footer/navigation-footer.component';
import {ForgotPasswordPopupComponent} from './pages/login/components/forgot-password/forgot-password-popup.component';
import {LoginResetPasswordComponent} from "./pages/login/components/reset-password/login-reset-password.component";
import {SendConfigModalComponent} from "./components/send-config-modal/send-config-modal.component";
import {EditModuleModalComponent} from "./components/edit-module-modal/edit-module-modal.component";
import {PromptDialogComponent} from "./components/prompt-dialog/prompt-dialog.component";
import {EditOwnPasswordComponent} from "./components/edit-own-password/edit-own-password.component";
import {
  ModuleConfigurationModalComponent
} from './components/module-configuration-modal/module-configuration-modal.component';
import {PlannerMapComponent} from './pages/planner/components/planner-map/planner-map.component';
import { PlannerListComponent } from './pages/planner/components/planner-list/planner-list.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgSelectModule,
    BrowserAnimationsModule,
    DialogModule,
    ɵEmptyOutletComponent,
    AgmCoreModule,
    AgmMarkerSpiderModule,
    RouterLink,
    RouterOutlet,
    RouterLinkActive
  ],
  declarations: [
    RootPageComponent,
    InstallBuildingComponent,
    InstallHeatingComponent,
    InstallHeatingCheckComponent,
    InstallHeatingInformationComponent,
    InstallSensorsComponent,
    DataResultComponent,
    ImageInputComponent,
    TabsComponent,
    InstallSensorsTemperatureComponent,
    InstallSensorsPumpComponent,
    InstallSensorsCounterComponent,
    InputCheckBoxComponent,
    InstallSensorsOtherComponent,
    InstallPhotosComponent,
    InputOnOffComponent,
    RawDataModalComponent,
    SerialNumberModalComponent,
    SpinnerComponent,
    InfoModalComponent,
    MinMaxNumberDirective,
    LoginComponent,
    InputImageUploadComponent,
    ImageModalComponent,
    PreviewModalComponent,
    AlertComponent,
    PlannerPageComponent,
    SiteDetailModalComponent,
    CreateSiteDetailModalComponent,
    InstallGeneralComponent,
    InstallGeneralGatewayComponent,
    InstallGeneralPrePhotosComponent,
    InstallPhotosComponent,
    InstallGeneralSendingComponent,
    InstallGeneralMeasurementComponent,
    InstallSensorsControlComponent,
    NavigationFooterComponent,
    ForgotPasswordPopupComponent,
    LoginResetPasswordComponent,
    PromptDialogComponent,
    EditOwnPasswordComponent,
    ModuleConfigurationModalComponent,
    EditModuleModalComponent,
    SendConfigModalComponent,
    PlannerMapComponent,
    PlannerListComponent
  ],
  providers: [],
  exports: [
    AlertComponent
  ]
})
export class ShellModule {
}
